import React, { useEffect, useRef, useState } from 'react';
import queryString from 'query-string';
import { useLocation, useHistory } from 'react-router-dom';
import PromotionTabs from './PromotionTabs';
import CartIcon from '../../promotion/CartIcon';
import AmwayPromotion from './AmwayPromotion/AmwayPromotion';
import RegularProduct from './RegularProduct/RegularProduct';
import { SOPProfileListLineOrdering } from '../../sop';
import commonConstant, { LINE_ORDERING_TABS_MAPPING, } from '../../../common/commonConstant';
import './LineOrdering.scss';
import { useSelector } from 'react-redux';

export default function LineOrdering(props) {
  const headerRef = useRef(null);
  const history = useHistory()
  const location = useLocation();
  const params = queryString.parse(location.search);
  const { notFromCartPage = true } = props;
  const [activeTab, setActiveTab] = useState(params['active'] || LINE_ORDERING_TABS_MAPPING.Amway.name);
  const [accountType, setAccountType] = useState('ABO');
  const customer = useSelector(state => state.customer);
  let TabToDisplay;

  useEffect(() => {
    if (customer.type) {
      setAccountType(customer.type);
    }
  }, [customer])

  switch (activeTab) {
    case LINE_ORDERING_TABS_MAPPING.NonAmway.name:
    case LINE_ORDERING_TABS_MAPPING.Amway.name:
      TabToDisplay = <AmwayPromotion activeTab={activeTab} />;
      break;
    case LINE_ORDERING_TABS_MAPPING.Regular.name:
      TabToDisplay = <RegularProduct accountType={accountType} />;
      break;
    case LINE_ORDERING_TABS_MAPPING.MySOP.name:
      TabToDisplay = <SOPProfileListLineOrdering />;
      break;
    default:
      break;
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (activeTab) {
      params.set('active', activeTab);
    }
    history.push({ search: params.toString() });
  }, [activeTab])

  const handleSearchRedirection = () => {
    history.push(commonConstant.pathLineOrderingSearch);
  }

  const renderProfileHeader = () => {
    return (
      <div className='header-container' ref={headerRef}>
        <div className="heading-container">
          <h2 className='title'>{LINE_ORDERING_TABS_MAPPING[activeTab].headerLabel}</h2>
          <div className='heading-container-icons'>
            {activeTab === LINE_ORDERING_TABS_MAPPING.Regular.name &&
              <div className='search-icon-circle' onClick={() => handleSearchRedirection()}>
                <img src='/images/promotion/icon-search-black.svg' />
              </div>
            }
            <div className='ln-icon-container'>
              <CartIcon />
            </div>
          </div>
        </div>
        <PromotionTabs tabCount={3} activeTab={activeTab} tabs={LINE_ORDERING_TABS_MAPPING} onTabClick={setActiveTab} />
      </div>
    )
  }

  return (
    <div className='line-ordering-container'>
      {notFromCartPage && renderProfileHeader()}
      <div className='tab-content'>
        {TabToDisplay}
      </div>
    </div>
  )
}
